<template>
  <div class="app-container">
    <FaqPanel
      page="conversion_tracker_s2s"
      :top-offset="50"
      :max-width="350"
      :backdrop="true"
    />
    <el-container>
      <el-main class="tracker-container">
        <div class="tab-container">
          <el-tabs v-model="activeTab" @tab-click="changeTab">
            <el-tab-pane key="s2s" label="S2S Postback url" name="s2s">
              <TabS2S v-if="activeTab === 's2s'" :jid="jobId" />
            </el-tab-pane>
            <el-tab-pane key="pixel" label="Pixel" name="pixel">
              <TabPixel v-if="activeTab === 'pixel'" :jid="jobId" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script lang="ts">
import { computed, ref, defineComponent } from 'vue'
import TabPixel from './components/TabPixel.vue'
import TabS2S from './components/TabS2S.vue'

import useRouter from '@/hooks/useRouter'
import FaqPanel from '@/components/FaqPanel/Index.vue'

export default defineComponent({
  name: 'Tracker',
  components: {
    TabPixel,
    TabS2S,
    FaqPanel
  },
  props: {
    jid: {
      type: String,
      default: null
    }
  },
  setup(props, context) {
    const loading = ref(false)

    const { route, router } = useRouter()

    const activeTab = ref(route.value.meta.type)

    const jobId = computed(() => {
      return props.jid
    })

    const changeTab = ({ name }: { name: string }) => {
      router.push({ name: name })
    }

    return {
      loading,
      activeTab,
      changeTab,
      jobId
    }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-card.is-always-shadow) {
  box-shadow: none;
}
.tracker-container {
  padding: 0 5px;
}
</style>
